var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83496 8.65523C4.51996 9.34023 5.44496 9.76023 6.48996 9.76023C8.54996 9.76023 10.25 8.09023 10.25 6.00023C10.25 3.91023 8.57996 2.24023 6.48996 2.24023C5.44496 2.24023 4.51996 2.66023 3.83496 3.34523",
    stroke: "white",
    strokeWidth: 0.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53491 5.015C5.77491 4.775 6.12991 4.625 6.48991 4.625C7.23491 4.625 7.85991 5.22 7.85991 5.995C7.85991 6.77 7.26491 7.365 6.48991 7.365C6.18991 7.335 5.89491 7.245 5.68491 7.065",
    stroke: "white",
    strokeWidth: 0.67
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.79494C1.75 7.00994 1.85 7.50494 2.615 7.55994C3.34 7.60994 3.875 7.57994 4.01 7.10994C4.145 6.63994 3.835 6.36494 3.525 6.22994C3.37 6.15994 3.085 6.06994 2.805 5.98994C2.42 5.87994 2.26 5.80994 2.04 5.59494C1.8 5.35494 1.695 4.50494 2.675 4.43994H3.085C3.395 4.46494 3.625 4.57494 3.805 4.76494C3.92 4.88994 3.995 5.03494 4.035 5.20494C4.055 5.29494 4.065 5.39494 4.065 5.49494",
    stroke: "white",
    strokeWidth: 0.67
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93994 3.68994V4.36494",
    stroke: "white",
    strokeWidth: 0.67
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93994 7.62988V8.30488",
    stroke: "white",
    strokeWidth: 0.67
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayIcon);
export default __webpack_public_path__ + "static/media/pay-icon.7108ec8964560c424ad8ded823f97ee0.svg";
export { ForwardRef as ReactComponent };